import { useEffect } from 'react';
import { RoutePath } from '@constants/routes';

export const useImpersonalization = () => {
    // INFO: Impersonalization feature
    useEffect(() => {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if (params.token && window.location.pathname === RoutePath.Home) {
            localStorage.setItem('user', JSON.stringify({ token: params.token }));
        }
    }, []);
};
